import "../App.css";
import { useState } from "react";

function ContactPage() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    location: "",
    datetime: "",
    message: "",
  });

  // name, email, phone, location, datetime, message

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${API_BASE_URL}/submit`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setFormData({
          name: "",
          email: "",
          phone: "",
          location: "",
          datetime: "",
          message: "",
        });
        setIsSubmitted(true); // Trigger animation
        setTimeout(() => setIsSubmitted(false), 1000);
      } else {
        alert("Failed to submit the form.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("An error occurred. Please try again.");
    }
  };

  return (
    <div>
      {/* <Navbar /> */}
      <div className="contact-page">
        <h2 className="contact-title">Let's get in touch</h2>
        <form onSubmit={handleSubmit} className="contact-form">
          <div className="form-group">
            <label htmlFor="name">name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="form-control"
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">email address</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="form-control"
            />
          </div>

          <div className="form-group">
            <label htmlFor="phone">contact number</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              className="form-control"
            />
          </div>
          <div className="form-group">
            <label htmlFor="location">location</label>
            <input
              type="tel"
              id="location"
              name="location"
              value={formData.location}
              onChange={handleChange}
              className="form-control"
            />
          </div>
          <div className="form-group">
            <label htmlFor="datetime">date / time of event</label>
            <textarea
              id="datetime"
              name="datetime"
              rows="5"
              value={formData.datetime}
              onChange={handleChange}
              className="form-control"
            ></textarea>
          </div>

          <div className="form-group">
            <label htmlFor="message">message</label>
            <textarea
              id="message"
              name="message"
              rows="5"
              value={formData.message}
              onChange={handleChange}
              required
              className="form-control"
            ></textarea>
          </div>

          <button
            type="submit"
            className={`${isSubmitted ? "submitted" : "notSubmitted"}`}
          >
            {isSubmitted ? "message sent" : "send message"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ContactPage;
